export default __webpack_public_path__ + "static/media/jersey.51031b95.jpg";